export enum EmbedTokenType {
	CHAT = 'chat',
	ACTIVITY = 'activity',
}
